import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import AuthPage from "./pages/Auth";
import AdminPage from "./pages/Admin";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PdfUploadPage from "./pages/admin/PdfUpload";
import ImageUploadPage from "./pages/admin/ImageUpload";
import OcrPage from "./pages/admin/Ocr";
import LibrariesPage from "./pages/admin/Libraries";
import CategoriesPage from "./pages/admin/Categories";
import CountriesPage from "./pages/admin/Countries";
import LanguagesPage from "./pages/admin/Languages";
import BrandsPage from "./pages/admin/Brands";
import ShopsPage from "./pages/admin/Shops";
import ProductsPage from "./pages/admin/Products";
import UsersPage from "./pages/admin/Users";
import LogsPage from "./pages/admin/Logs";
import Angebot from "./pages/admin/Angebot";
import DicingPage from "./pages/admin/Dicing";
import GroupDicingPage from "./pages/admin/GroupDicingPage";
import GroupAnnotator from "./pages/admin/GroupAnnotator";
import ActionPresetsPage from "./pages/admin/ActionPresets";
import DiscountsPage from "./pages/Discounts";
import ProductIdentifierView from "./pages/admin/ProductIdentifierView";
import DepositsPage from "./pages/admin/Deposits";
import ExtPage from "./pages/admin/Ext";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <AuthProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/discounts" element={<DiscountsPage />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/admin" element={<AdminPage />}>
                <Route index element={<Navigate to="/admin/pdf-upload" replace />} />
                <Route path="pdf-upload" element={<PdfUploadPage />} />
                <Route path="image-upload" element={<ImageUploadPage />} />
                <Route path="ocr" element={<OcrPage />} />
                <Route path="libraries" element={<LibrariesPage />} />
                <Route path="categories" element={<CategoriesPage />} />
                <Route path="countries" element={<CountriesPage />} />
                <Route path="languages" element={<LanguagesPage />} />
                <Route path="brands" element={<BrandsPage />} />
                <Route path="shops" element={<ShopsPage />} />
                <Route path="products" element={<ProductsPage />} />
                <Route path="action-presets" element={<ActionPresetsPage />} />
                <Route path="angebot" element={<Angebot />} />
                <Route path="dicing" element={<DicingPage />} />
                <Route path="dicing/:libraryId" element={<GroupDicingPage />} />
                <Route path="annotator/:libraryId/:sliceId?" element={<GroupAnnotator />} />
                <Route path="product-identifier" element={<ProductIdentifierView />} />
                <Route path="deposits" element={<DepositsPage />} />
                <Route path="ext" element={<ExtPage />} />
                <Route path="users" element={<UsersPage />} />
                <Route path="logs" element={<LogsPage />} />
              </Route>
            </Route>

            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;